import {Component, Input, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {MenuGroup, MenuItem} from "../../../../common";

@Component({
  selector: 'breadcrumb',
  standalone: false,
  template: `
    <div class="container fixed-top breadcrumb-component" *ngIf="hasParent()">
      <div class="row">
        <div class="col col-auto align-self-center">
          <a class="btn btn-link" [routerLink]="['/grp', getParentId()]"><i class="fas fa-arrow-circle-left"></i></a>
        </div>
        <div class="col pl-0">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0">
              <!--<li class="breadcrumb-item"><a [routerLink]="['/']"><i class="fa fa-home"></i></a></li>-->
              <li *ngFor="let parent of getParents()" class="breadcrumb-item">
                <a [routerLink]="['/grp', parent.id]">{{ parent.name }} </a>
              </li>
              <li *ngIf="hasActive()" class="breadcrumb-item active" aria-current="page"><a>{{ getActive() }}</a></li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .breadcrumb-component {
      top: 54px;
    }

    .breadcrumb {
      background-color: transparent;
      padding-left: 0;
    }

    .breadcrumb a {
      text-decoration: none;
    }

    .breadcrumb-item:last-child a {
      font-weight: bold;
    }

    .breadcrumb-item + .breadcrumb-item::before {
      content: "»";
      color: #9fa4a8;
    }
  `]
})

export class Breadcrumb implements OnChanges, OnDestroy {

  @Input() group: MenuGroup = null;
  @Input() item: MenuItem = null;

  ngOnChanges() {
    if (this.hasParent()) {
      document.querySelector('body').classList.add('has-breadcrumb')
    } else {
      document.querySelector('body').classList.remove('has-breadcrumb')
    }
  }

  ngOnDestroy() {
    document.querySelector('body').classList.remove('has-breadcrumb')
  }

  hasParent() {
    if (this.item) {
      return true;
    } else {
      return this.group.parent;
    }
  }

  getParentId() {
    if (this.item) {
      return this.item.group.id;
    } else {
      return this.group.parent;
    }
  }

  getParents() {
    if (this.item) {
      return this.item.getParents();
    } else {
      return this.group.getParents();
    }
  }

  getActive() {
    if (this.item) {
      return this.item.name;
    } else {
      return this.group.name;
    }
  }

  hasActive() {
    return !(this.item);
  }

}
